const API_URL = 'https://fxr2v6doz6.execute-api.us-east-1.amazonaws.com/Development/newsletter';

const subscribeNewsletterUser = async ({ email }) => {
  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      body: JSON.stringify({ email }),
      headers: {
        'Content-type': 'Application/json',
      },
    });
    if (response.status !== 201) {
      throw new Error('Something happend with the request');
    }
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const handleSubmit =  ({ errorSetter, email, language }) => async () => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!email.match(emailRegex)) {
    errorSetter({
      field: 'email',
      errorMessage: language === 'en' ? 'Please enter a valid email' : 'Ingresa un correo válido',
      errorStatus: true,
    });
    return;
  } else {
    errorSetter({
      field: 'email',
      errorMessage: '',
      errorStatus: false,
    });
  }
  const  subscribeSuccesfully = await subscribeNewsletterUser({ email });
  if (!subscribeSuccesfully) {
    errorSetter({
      field: 'email',
      errorMessage: 'Server error, please try again',
      errorStatus: false,
    });
  }
};
